var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVenly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8469 10.1917L19.7983 9.46222C19.8894 9.42315 19.9935 9.52735 19.9284 9.61854L14.1522 19.1018C14.1002 19.1929 13.9961 19.245 13.879 19.245H10.1063C10.0022 19.245 9.89812 19.1799 9.83307 19.0887L4.06988 9.61854C4.01785 9.52735 4.10891 9.42315 4.19998 9.46222L6.13839 10.2047C6.21644 10.2308 6.2945 10.1526 6.26848 10.0745L4.0959 4.82483C4.06988 4.74667 4.13493 4.66851 4.226 4.69456L8.35 6.12747C8.42805 6.15352 8.4931 6.21865 8.53213 6.29681L11.3422 13.305C11.3812 13.3962 11.2901 13.4744 11.1991 13.4483L9.4558 12.81C9.35172 12.7709 9.27367 12.8751 9.32571 12.9663L11.8886 17.2911C11.9406 17.3823 12.0837 17.3823 12.1357 17.2911L14.6986 12.9663C14.7506 12.8751 14.6596 12.7709 14.5685 12.81L12.8252 13.4483C12.7342 13.4874 12.6431 13.3962 12.6821 13.305L15.4792 6.29681C15.5052 6.21865 15.5702 6.15352 15.6613 6.12747L19.7853 4.69456C19.8634 4.66851 19.9414 4.74667 19.9154 4.82483L17.7428 10.0614C17.6778 10.1396 17.7688 10.2178 17.8469 10.1917Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVenly);
export default __webpack_public_path__ + "static/media/logo-venly.2c51daa4d8001b958f2438acc88cdfd7.svg";
export { ForwardRef as ReactComponent };